// extracted by mini-css-extract-plugin
module.exports = {"loaderMainContainer":"loader_loaderMainContainer__3syhf","content":"loader_content__BNK5d","spinnerContainer":"loader_spinnerContainer__3t_EA"};